import BaoDialog from "./../../factories/bao-dialog";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import signotecDialogTemplate from "./signotec-dialog-template.html";
import * as moment from "moment";
import { DialogViewModel } from "../factories/js-manager";
export interface SignotecResult {
    Result: boolean;
    Data: string;
    DateValue: string;
    NameValue: string;
}
export class SignotecSignDialog {
    private _currentPromise: JQueryDeferred<SignotecResult>;
    private _currentDialogVM: DialogViewModel;

    public Open(dialogVM: DialogViewModel): JQueryPromise<SignotecResult> {
        this._currentPromise = $.Deferred<SignotecResult>();
        this._currentDialogVM = dialogVM;
       
        this._imageBinary64 = "";
        if (this._websocketConnectionAlreadyOpen) {
            this.PleaseUseDialog();
            // we set the dialog here and in front of "signature_start" to catch possible error messages w/o also showing this dialog            
        }
        else {
            this.openWebSocket();
        }
        return this._currentPromise.promise();
    }
    private ResolvePromise(data: string, result: boolean) {

         // remove focus from datebox to persist value
         this._pleaseUsePadDialog?.ViewModel().FocusDateBox(false);

        //reset some variables      
        this._currentSearchState = this._searchStates.setPadType;
        this._currentOpenState = this._openStates.openPad;
        if (this._pleaseUsePadDialog != null) {
            this._pleaseUsePadDialog.Close();
        }
        if (this._currentPromise != null) {
            var dateValue = null;
            var nameValue = null;
            if (this._pleaseUsePadDialog?.ViewModel().DateVisible) {
                dateValue = this._pleaseUsePadDialog.ViewModel().DateValue();
            }
            if (this._pleaseUsePadDialog?.ViewModel().NameVisible) {
                nameValue = this._pleaseUsePadDialog.ViewModel().NameValue();
            }
            this._currentPromise.resolve({ Data: data, Result: result, DateValue: dateValue, NameValue: nameValue });
        }
        this._currentPromise = null;
        this._websocketConnectionAlreadyOpen = false;
    }
    private _imageBinary64: string = "";
    private _websocket: any = null;
    private _websocketConnectionAlreadyOpen = false; //possibly not needed anymore due to singleton?
    private _wsUri = "wss://local.signotecwebsocket.de:49494";
    private _searchStates = {
        setPadType: 0,
        search: 1,
        getInfo: 2,
        getVersion: 3
    };
    private _openStates = {
        openPad: 0,
        getDisplayWidth: 1,
        getDisplayHeight: 2,
        getResolution: 3
    };
    private _preparationStates = {
        setBackgroundTarget: 0,
        setBackgroundImage: 1,
        setCancelButton: 2,
        setRetryButton: 3,
        setConfirmButton: 4,
        setSignRect: 5,
        setFieldName: 6,
        setCustomText: 7,
        setForegroundTarget: 8,
        switchBuffers: 9,
        startSignature: 10
    };
    private _currentSearchState = this._searchStates.setPadType;
    private _currentOpenState = this._openStates.openPad;
    private _currentPreparationState = this._preparationStates.setBackgroundTarget;
    private _cancelButton = -1;
    private _retryButton = -1;
    private _confirmButton = -1;
    private _buttonDiff = 0;
    private _buttonLeft = 0;
    private _buttonTop = 0;
    private _buttonSize = 0;
    /**
     * Event handler for websocket communication
     * **/
    private onMessage = (evt) => {
        var message = evt.data;
        var ret = null;
        var obj = JSON.parse(message);
        if (obj.TOKEN_TYPE === "TOKEN_TYPE_SEND") {
            if (obj.TOKEN_CMD === "TOKEN_CMD_SIGNATURE_CONFIRM") {
                // confirm signing process
                this.signature_confirm();
            }
            else if (obj.TOKEN_CMD === "TOKEN_CMD_SIGNATURE_RETRY") {
                // restart signing process
                this.signature_retry();
            }
            else if (obj.TOKEN_CMD === "TOKEN_CMD_SIGNATURE_CANCEL") {
                // cancel signing process
                this.signature_cancel();
            }
            else if (obj.TOKEN_CMD === "TOKEN_CMD_DISCONNECT") {
                //the opened pad has been disconnected
                this.disconnect();
            }
            else {
                // do nothing
            }
        }
        else if (obj.TOKEN_TYPE === "TOKEN_TYPE_RESPONSE") {
            if ((obj.TOKEN_CMD_ORIGIN === "TOKEN_CMD_SIGNATURE_CONFIRM")) {
                //check the return code
                ret = obj.TOKEN_PARAM_RETURN_CODE;
                if (ret < 0) {
                    //alert("Failed to confirm the signature. Reason: " + obj.TOKEN_PARAM_ERROR_DESCRIPTION);  // only commented out, bc the alert message shows what type of error we have
                    this.close_pad();
                    this.ResolvePromise(obj.TOKEN_PARAM_ERROR_DESCRIPTION, false);
                    return;
                }
                this.signature_sign_data();
            }
            else if (obj.TOKEN_CMD_ORIGIN === "TOKEN_CMD_SIGNATURE_SIGN_DATA") {
                //check the return code
                ret = obj.TOKEN_PARAM_RETURN_CODE;
                if (ret < 0) {
                    //alert("Failed to get signature SignData. Reason: " + obj.TOKEN_PARAM_ERROR_DESCRIPTION);
                    this.ResolvePromise(obj.TOKEN_PARAM_ERROR_DESCRIPTION, false);
                    this.close_pad();
                    return;
                }
                this._imageBinary64 = obj.TOKEN_PARAM_SIGNATURE_SIGN_DATA; //TODO: check, what kind of data we get here - i think it's some "sign information", regarding how fast someone signed for example
                this.signature_image();
            }
            else if (obj.TOKEN_CMD_ORIGIN === "TOKEN_CMD_SIGNATURE_IMAGE") {
                //check the return code
                ret = obj.TOKEN_PARAM_RETURN_CODE;
                if (ret < 0) {
                    //alert("Failed to get signature image. Reason: " + obj.TOKEN_PARAM_ERROR_DESCRIPTION);
                    this.ResolvePromise(obj.TOKEN_PARAM_ERROR_DESCRIPTION, false);
                    this.close_pad();
                    return;
                }
                let data = "data:image/png;base64," + obj.TOKEN_PARAM_FILE;
                this.ResolvePromise(data, true);
                this._pleaseUsePadDialog.Close();
                this.close_pad();
            }
            else if ((obj.TOKEN_CMD_ORIGIN === "TOKEN_CMD_SIGNATURE_RETRY")) {
                //check the return code
                ret = obj.TOKEN_PARAM_RETURN_CODE;
                if (ret < 0) {
                    //alert("Failed to restart signature process. Reason: " + obj.TOKEN_PARAM_ERROR_DESCRIPTION);
                    this.ResolvePromise(obj.TOKEN_PARAM_ERROR_DESCRIPTION, false);
                    this.close_pad();
                    return;
                }
            }
            else if ((obj.TOKEN_CMD_ORIGIN === "TOKEN_CMD_SIGNATURE_CANCEL")) {
                //check the return code
                ret = obj.TOKEN_PARAM_RETURN_CODE;
                if (ret < 0) {
                    //alert("Failed to cancel signature process. Reason: " + obj.TOKEN_PARAM_ERROR_DESCRIPTION);
                    this.ResolvePromise(obj.TOKEN_PARAM_ERROR_DESCRIPTION, false);
                    this.close_pad();
                    return;
                }
                this._pleaseUsePadDialog.Close();
                this.close_pad();
            }
            else if (obj.TOKEN_CMD_ORIGIN === "TOKEN_CMD_SEARCH_FOR_PADS") {
                //check the return code
                ret = obj.TOKEN_PARAM_RETURN_CODE;
                if (ret < 0) {
                    //alert("The search for pads failed. Reason: " + obj.TOKEN_PARAM_ERROR_DESCRIPTION);                    
                    this.ResolvePromise(obj.TOKEN_PARAM_ERROR_DESCRIPTION, false);
                    return;
                }
                //check for connected pads
                if (obj.TOKEN_PARAM_CONNECTED_PADS === undefined || obj.TOKEN_PARAM_CONNECTED_PADS == 0 || obj.TOKEN_PARAM_CONNECTED_PADS === null) {
                    //alert("No connected pads have been found.");  
                    this.ResolvePromise("No connected pads have been found", false);
                    return;
                }
                this.open_pad();
            }
            else if (obj.TOKEN_CMD_ORIGIN === "TOKEN_CMD_OPEN_PAD") {
                //check the return code
                ret = obj.TOKEN_PARAM_RETURN_CODE;
                if (ret < 0) {
                    return;
                }
                //start the signature process
                if (this._websocketConnectionAlreadyOpen) {
                    this.PleaseUseDialog();
                }
                this.signature_start();
            }
            else if (obj.TOKEN_CMD_ORIGIN === "TOKEN_CMD_SIGNATURE_START") {
                //check the return code
                ret = obj.TOKEN_PARAM_RETURN_CODE;
                if (ret < 0) {
                    // alert("Failed to start signature process. Reason: " + obj.TOKEN_PARAM_ERROR_DESCRIPTION);
                    this.close_pad();
                    this.ResolvePromise(obj.TOKEN_PARAM_ERROR_DESCRIPTION, false);
                    //this.OpenSignDialogNormal(self.relatedField, self.matchcodeDate, self.matchcodeName);
                    return;
                }
            }
            else if ((obj.TOKEN_CMD_ORIGIN === "TOKEN_CMD_CLOSE_PAD")) {
                ret = obj.TOKEN_PARAM_RETURN_CODE;
                if (ret < 0) {
                    //alert("Failed to close pad. Reason: " + obj.TOKEN_PARAM_ERROR_DESCRIPTION);
                    this.ResolvePromise(obj.TOKEN_PARAM_ERROR_DESCRIPTION, false);
                    return;
                }
            }
            else {
                // do nothing
            }
        }
        else {
            // do nothing
        }
    };
    private onOpen(evt) {
        this._websocketConnectionAlreadyOpen = true;
        this.search_for_pads();
    }
    private onClose(evt) {
    }
    private onError(evt) {
        this.ResolvePromise("websocket error", false);
    }
    private openWebSocket = () => {
        this._websocket = new WebSocket(this._wsUri);
        this._websocket.onopen = (evt) => { this.onOpen(evt); };
        this._websocket.onclose = (evt) => { this.onClose(evt); };
        this._websocket.onerror = (evt) => { this.onError(evt); };
        this._websocket.onmessage = (evt) => { this.onMessage(evt); };
    };
    private PleaseUseDialog() {
        this._pleaseUsePadDialog = new BaoDialog(Bao.Session.ApplicationName);
        this._pleaseUsePadDialog.ViewModel({
            Bao: Bao,
            Info: Bao.Session.GetMessage("msgSubscribeSignotec"),
            DateVisible: this._currentDialogVM.DateVisible,
            NameVisible: this._currentDialogVM.NameVisible,
            DateValue: this._currentDialogVM.DateValue,
            NameValue: this._currentDialogVM.NameValue,
            FirstElement: ko.observable(),
            DateInput: ko.observable(),
            PickerMode: ko.observable(this._currentDialogVM.PickerMode),
            UsernameReadonly: ko.observable(this._currentDialogVM.UsernameReadOnly),
            FocusDateBox: ko.observable(false)
        });
        this._pleaseUsePadDialog.Buttons([{
                Title: Bao.Session.GetMessage("msgCancel"), Click: () => {
                    this.close_pad();
                    this._pleaseUsePadDialog.Close();
                },
                Enabled: ko.observable(true)
            }]);

        // close signotec pad when dialog is cancelled with the "X" button.    
        this._pleaseUsePadDialog.CloseButtonClicked = () => {
            this.close_pad();
            this._pleaseUsePadDialog.Close();
        };     

        this._pleaseUsePadDialog.Width("600px");
        this._pleaseUsePadDialog.Template(signotecDialogTemplate);
        this._pleaseUsePadDialog.Open();
        
        if (Bao.Utils.String.IsNullOrEmpty(this._currentDialogVM.DateValue())) {
            this._pleaseUsePadDialog.ViewModel().DateValue(moment().format(Bao.Utils.DateTimeFormat));
        }
        $(this._pleaseUsePadDialog.ViewModel().FirstElement()).parent().css("overflow", "visible"); //fix for dialog control
    }
    private clearSignature = () => {
        this._imageBinary64 = "";
    };
    private search_for_pads = () => {
        var message = '{ "TOKEN_TYPE":"TOKEN_TYPE_REQUEST", "TOKEN_CMD":"TOKEN_CMD_SEARCH_FOR_PADS", "TOKEN_PARAM_PAD_SUBSET":"HID" }';
        this._websocket.send(message);
    };
    private open_pad = () => {
        //open the pad with index 0
        var message = '{ "TOKEN_TYPE":"TOKEN_TYPE_REQUEST", "TOKEN_CMD":"TOKEN_CMD_OPEN_PAD", "TOKEN_PARAM_PAD_INDEX":"0" }';
        this._websocket.send(message);
    };
    // TOKEN_CMD_CLOSE_PAD
    private close_pad = () => {
        var message = '{ "TOKEN_TYPE":"TOKEN_TYPE_REQUEST", "TOKEN_CMD":"TOKEN_CMD_CLOSE_PAD", "TOKEN_PARAM_PAD_INDEX":"0" }';
        this._websocketConnectionAlreadyOpen = false; // now another connection can be opened
        this._websocket.send(message);
    };
    private signature_start = () => {
        var message = '{ "TOKEN_TYPE":"TOKEN_TYPE_REQUEST", "TOKEN_CMD":"TOKEN_CMD_SIGNATURE_START", "TOKEN_PARAM_FIELD_NAME":"Signature 1", "TOKEN_PARAM_CUSTOM_TEXT":"Please sign!" }';
        this._websocket.send(message);
    };
    private signature_confirm = () => {
        var message = '{ "TOKEN_TYPE":"TOKEN_TYPE_REQUEST", "TOKEN_CMD":"TOKEN_CMD_SIGNATURE_CONFIRM" }';
        this._websocket.send(message);
    };
    private signature_retry = () => {
        var message = '{ "TOKEN_TYPE":"TOKEN_TYPE_REQUEST", "TOKEN_CMD":"TOKEN_CMD_SIGNATURE_RETRY" }';
        this._websocket.send(message);
    };
    private signature_cancel = () => {
        var message = '{ "TOKEN_TYPE":"TOKEN_TYPE_REQUEST", "TOKEN_CMD":"TOKEN_CMD_SIGNATURE_CANCEL" }';
        this._websocket.send(message);
    };
    private signature_image = () => {
        var message = '{ "TOKEN_TYPE":"TOKEN_TYPE_REQUEST", "TOKEN_CMD":"TOKEN_CMD_SIGNATURE_IMAGE' +
            '", "TOKEN_PARAM_FILE_TYPE":"' + '1' + // PNG
            '", "TOKEN_PARAM_PEN_WIDTH":"' + '5' +
            '" }';
        this._websocket.send(message);
    };
    private signature_sign_data = () => {
        var message = '{ "TOKEN_TYPE":"TOKEN_TYPE_REQUEST", "TOKEN_CMD":"TOKEN_CMD_SIGNATURE_SIGN_DATA" }';
        this._websocket.send(message);
    };
    /**
     * Can occure when someone disconnects the pad from usb
     * **/
    private disconnect = () => {
        if (this._websocket != null) {
            this._websocket.close();
            this._websocketConnectionAlreadyOpen = false;
        }
        this.ResolvePromise("pad disconnected", false);
    };
    private _pleaseUsePadDialog = null;
    private OpenPleaseUseDialog = () => {
        this._pleaseUsePadDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSubscribeSignotec"));
        this._pleaseUsePadDialog.Buttons([{
                Title: Bao.Session.GetMessage("msgCancel"), Click: () => {
                    this.close_pad();
                    this._pleaseUsePadDialog.Close();
                },
                Enabled: ko.observable(true)
            }]);
        this._pleaseUsePadDialog.Width("400px");
        this._pleaseUsePadDialog.Open();
    };
}
export default new SignotecSignDialog();